// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1n-e";
export var animationRelative = "_1n-d";
export var backdropBlur = "_1n-0";
export var detailLabelCell = "_1n-q";
export var detailTable = "_1n-p";
export var detailValueCell = "_1n-r";
export var documentTypeIcon = "_1n-y";
export var documentTypeOption = "_1n-x";
export var dropdownMatchDatePicker = "_1n-3";
export var evidenceCardContent = "_1n-w";
export var gorgiasTicketCard = "_1n-s";
export var iconTertiary = "_1n-z";
export var integrationCard = "_1n-1";
export var integrationLogoBox = "_1n-2";
export var mainColumnSticky = "_1n-v";
export var maxWidthContainer = "_1n-t";
export var modalContentBody = "_1n-a";
export var modalHeaderImage = "_1n-5";
export var modalImageLabel = "_1n-7";
export var modalImageOverlay = "_1n-6";
export var modalImageSubtitle = "_1n-9";
export var modalImageTitle = "_1n-8";
export var modalImageWrapper = "_1n-4";
export var modalStickyFooter = "_1n-b";
export var sidebarColumn = "_1n-u";
export var timelineLine = "_1n-m";
export var timelineLineBlack = "_1n-o _1n-m";
export var timelineLineGray = "_1n-n _1n-m";
export var timelineLineHeight = "_1n-l";
export var tlDotActivate = "_1n-i";
export var tlDotActivateAnim = "_1n-h";
export var tlDotHide = "_1n-g";
export var tlDotHideAnim = "_1n-f";
export var tlLineActivate = "_1n-k";
export var tlLineActivateAnim = "_1n-j";
export var uploadedFileRow = "_1n-c";